import { deforestationSadSumType } from 'store/typesActions/types';

const initialState = {
	deforestationSadSum: {},
	isLoading: false,
	error: false,
	message: ''
};

export default function deforestationSadSumReducer(state = initialState, action) {
	const { errors } = action?.payload || { erros: {} };

	switch (action.type) {
		case deforestationSadSumType.DEFORESTATION_SAD_SUM:
			return {
				...state,
				isLoading: true,
				error: false,
				message: 'Buscando dados do desmatamento'
			};

		case deforestationSadSumType.DEFORESTATION_SAD_SUM_SUCCESS:
			return {
				deforestationSadSum: action.payload,
				isLoading: false,
				error: false,
				message: ''
			};

		case deforestationSadSumType.DEFORESTATION_SAD_SUM_ERROR:
			return {
				...state,
				deforestationSadSum: [],
				isReq: false,
				error: true,
				message: 'Erro ao buscar por dados, tente novamente mais tarde'
			};
		default:
			return state;
	}
}
